import { Box, Typography } from "@material-ui/core";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import { RankInYear } from "models/auth";
import React from "react";
import { useTranslation } from "react-i18next";
import { Chart, registerables } from "chart.js";
import { Line } from "react-chartjs-2";
Chart.register(...registerables);

interface ChartRankingProps {
  ranking: any;
}

const ChartRanking = ({ ranking }: ChartRankingProps) => {
  const { t } = useTranslation();

  const formattedData = React.useMemo(() => {
    return (
      (ranking &&
        ranking.map((rank: RankInYear) => ({
          ...rank,
          month: `T${rank.month}/${rank.year}`,
        }))) ||
      []
    );
  }, [ranking]);

  const data = {
    labels: formattedData.map((item: any) => item.month),
    datasets: [
      {
        label: t("home.chart.hang") || "Hạng",
        data: formattedData.map((item: any) => item.ranking),
        fill: true,
        borderColor: "#4F46E5",
        backgroundColor: "rgba(79, 70, 229, 0.15)",
        tension: 0.4,
        pointBackgroundColor: "#FFFFFF",
        pointBorderColor: "#4F46E5",
        pointBorderWidth: 3,
        pointRadius: 5,
        pointHoverRadius: 7,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (context: any) => {
            return `${t("home.chart.hang") || "Hạng"}: #${context.raw}`;
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: "#64748B",
          font: {
            size: 11,
            weight: "600" as const,
          },
        },
      },
      y: {
        grid: {
          color: "#F1F5F9",
        },
        ticks: {
          color: "#64748B",
          font: {
            size: 11,
            weight: "600" as const,
          },
          precision: 0,
        },
      },
    },
  };

  return (
    <Box style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
      <Box style={{ display: "flex", alignItems: "center", marginBottom: 12, paddingLeft: 4 }}>
        <Typography style={{ fontWeight: 800, fontSize: "0.875rem", color: "#0F172A", display: "flex", alignItems: "center", gap: 6, letterSpacing: "0.02em" }}>
          <TrendingUpIcon style={{ fontSize: 18, color: "#2563EB" }} />
          DIỄN BIẾN XẾP HẠNG THEO THÁNG
        </Typography>
      </Box>

      <Box style={{ height: 230, width: "100%" }}>
        <Line data={data} options={options} />
      </Box>
    </Box>
  );
};

export default ChartRanking;
